<div nxLayout="grid maxwidth" class="policy-detail" *ngIf="policy">
    <div nxRow>
        <div nxCol="12">
            <nx-link class="go-back">
                <a routerLink='/moje-poistky'>
                    <nx-icon name='chevron-left'></nx-icon>
                    {{'policy.go-back' | translate}}
                </a>
            </nx-link>
        </div>
    </div>
    <div nxRow>
        <div nxCol="12">
            <cpc-policy-card [ngClass]="policy.policyState.name" [variant]="policy.policyState.badge">
                <cpc-policy-card-header class="cpc-policy-card-header_{{policy.policyState.badge}}">
                    <cpc-icon left [icon]="policy.groupIcon"
                        color="{{ (policy.isElectricVehicle) ? '#3da556' : '#006192' }}" borderStyle="circle"
                        backgroundColor="#fff">
                    </cpc-icon>
                    <ng-container center>
                        <p translate *ngIf="!policy.isElectricVehicle">
                            {{'active-insurance-group.' + policy.groupName}}</p>
                        <p translate *ngIf="policy.isElectricVehicle">
                            {{'active-insurance-group.car-insurance-ek'}}</p>
                        <p class="nameLine">
                            <cpc-badge [variant]="policy.policyState.badge">
                                {{'product-state.' + policy.policyState.name | translate}}
                                <cpc-icon icon="check-circle" color="#3DA556"></cpc-icon>
                            </cpc-badge>
                        </p>
                    </ng-container>
                    <ng-container right>
                    </ng-container>
                </cpc-policy-card-header>
                <cpc-policy-card-content class="policy-card-content">
                    <div nxRow>
                        <div nxCol="12, 12, 12, 6">
                            <cpc-policy-card-entry>
                                <span title translate>home.product-name</span>
                                <b>{{ this.b2b.getProductName(policy) }}</b>
                            </cpc-policy-card-entry>
                            <cpc-policy-card-entry>
                                <span title translate>policy.policy-number</span>
                                <b>{{policy.policyNumber | stringFormat}}</b>
                            </cpc-policy-card-entry>
                        </div>
                        <div nxCol="12, 12, 12, 6">
                            <cpc-policy-card-entry>
                                <span title translate>policy.instalment-amount</span>
                                <b class="termPremium">{{policy.termPremium | stringFormat |
                  currencyFormat : policy.premiumCurrency}}</b>
                                <app-payment-frequency class="payment-frequency"
                                    [paymentFrequencyId]="policy.paymentFrequencyId">
                                </app-payment-frequency>
                            </cpc-policy-card-entry>

                            <cpc-policy-card-entry class="payment-frequency">
                                <app-payment-frequency [paymentFrequencyId]="policy.paymentFrequencyId">
                                </app-payment-frequency>
                            </cpc-policy-card-entry>
                        </div>
                    </div>
                    <ng-template [ngIf]="!!policy.endDate">
                        <div class="policy-progress">
                            <cpc-policy-progress [startDate]="policy.beginDate" [endDate]="policy.endDate"
                                [isActiveBar]="policy.policyState === policyStates.active"
                                copyStart="{{'policy.start-date' | translate}}"
                                copyEnd="{{'policy.end-date' | translate}}">
                            </cpc-policy-progress>
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="!policy.endDate">
                        <div nxRow>
                            <div nxCol="12, 12, 12, 6">
                                <cpc-policy-card-entry>
                                    <span title translate>policy.start-date</span>
                                    <b>{{policy.beginDate | dateFormat}}</b>
                                </cpc-policy-card-entry>
                            </div>
                        </div>
                    </ng-template>
                </cpc-policy-card-content>

                <cpc-policy-card-content class="button-row">
                    <nx-accordion variant="extra-light" *ngIf="selectedCorrespondence.length > 0">
                        <nx-expansion-panel>
                            <nx-expansion-panel-header>
                                <nx-expansion-panel-title>
                                    {{'policy.show-documents' | translate}}
                                </nx-expansion-panel-title>
                            </nx-expansion-panel-header>
                            <div class="documents-dropdown">
                                <app-correspondence-simple-list [correspondenceList]="selectedCorrespondence"
                                    [downLoadDocumentUrl]="downLoadDocumentUrl">
                                </app-correspondence-simple-list>
                            </div>
                        </nx-expansion-panel>
                    </nx-accordion>
                </cpc-policy-card-content>
            </cpc-policy-card>
        </div>
    </div>

    <div nxRow>
        <div nxCol="12">
            <section class="nx-margin-top-l">
                <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-xs" translate>b2b.upload-form.headline</h3>
                <nx-card>
                    <form [formGroup]="uploadForm" (submit)="uploadFiles()">
                        <div nxRow>
                            <div nxCol="12,12,12,4">
                                <nx-formfield label="{{ 'policy.policy-number' | translate }}">
                                    <input nxInput formControlName="policyNumber" type="text" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,4">
                                <nx-formfield label="{{ 'b2b.upload-form.type' | translate }}">
                                    <input nxInput formControlName="type" type="text" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,4">
                                <nx-formfield label="{{ 'b2b.upload-form.category' | translate }}">
                                    <input nxInput formControlName="category" type="text" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12">
                                <nx-formfield label="{{ 'b2b.upload-form.note' | translate }}">
                                    <input nxInput formControlName="note" type="text" />
                                </nx-formfield>
                            </div>
                        </div>

                        <nx-file-uploader formControlName="document" required #documentUpload multiple
                            [uploader]="uploader" maxFileSize="{{10 * 1024 * 1024}}"
                            [itemTemplate]="uploadFileItemTemplate" [strictAcceptValidation]="true"
                            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.spreadsheet, image/jpeg, image/tiff, application/pdf, text/csv">
                            <nx-label size="small"
                                class="nx-margin-bottom-3xs">{{ 'b2b.upload-form.documents' | translate }}</nx-label>
                            <button nxButton="primary" type="button" class="nx-margin-bottom-s" nxFileUploadButton>
                                <nx-icon name="plus" class="nx-margin-right-2xs" aria-hidden="true"></nx-icon>
                                {{ 'b2b.upload-form.add-file' | translate }}
                            </button>

                            <nx-error>{{ 'b2b.upload-form.required-field' | translate }}</nx-error>
                        </nx-file-uploader>

                        <button nxButton="secondary small" type="submit" [disabled]="!uploadForm.valid">
                            {{ 'b2b.upload-form.submit' | translate }}
                        </button>
                    </form>
                </nx-card>
            </section>
        </div>
    </div>

    <div nxRow class="documents">
        <div nxCol="12">
            <h3 nxHeadline="subsection-medium" class="title" translate>policy.list-of-documents</h3>
            <nx-tab-group (selectedTabChange)="documentsTabChanged($event)" [(selectedIndex)]="documentsTabIndex">
                <nx-tab [label]="'b2b.documents.to-download' | translate">
                    <nx-card>
                        <ng-container [ngTemplateOutlet]="filter"></ng-container>
                        <ng-container [ngTemplateOutlet]="toDownload"></ng-container>
                    </nx-card>
                </nx-tab>
                <nx-tab [label]="'b2b.documents.sent-to-asp' | translate">
                    <nx-card>
                        <ng-container [ngTemplateOutlet]="filter"></ng-container>
                        <ng-container [ngTemplateOutlet]="sentToAsp"></ng-container>
                    </nx-card>
                </nx-tab>
            </nx-tab-group>
        </div>
    </div>
</div>

<ng-template #uploadFileItemTemplate let-templateContext="templateContext" let-file="file">
    <div nxLayout="grid maxwidth">
        <div nxRow nxRowAlignItems="center" nxRowJustify="between">
            <div nxCol="12,12,12,6">
                <div nxRow>
                    <div nxCol="12">
                        <nx-file-upload-name [name]="file?.name"></nx-file-upload-name>
                    </div>
                </div>
                <div nxRow>
                    <div nxCol="12" class="nx-margin-top-xs">
                        <nx-error appearance="text" nxFormfieldError *ngIf="file.errors != undefined">
                            {{ 'b2b.upload-form.errors.' + file.errors | translate }}
                        </nx-error>
                    </div>
                </div>
            </div>
            <div nxCol="12,12,12,6">
                <div class="nx-file-uploader--file-row-actions">
                    <nx-file-upload-status [isUploading]="file.isUploading" [isUploaded]="file.isUploaded"
                        [uploadedLabel]="templateContext.uploadedLabel"></nx-file-upload-status>
                    <nx-file-upload-delete [deleteLabel]="templateContext.deleteLabel" [isUploading]="file.isUploading"
                        (click)="templateContext.removeFile(file)"></nx-file-upload-delete>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #filter>
    <form [formGroup]="filterForm" (submit)="filterDocuments()">
        <div nxRow>
            <div nxCol="12,12,12,4">
                <nx-formfield label="{{ 'callMeBack.dateFieldLabel' | translate }}">
                    <input nxDatefield nxInput [datepicker]="dateFrom" formControlName="dateFrom"
                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                    <nx-datepicker-toggle [for]="dateFrom" nxFormfieldSuffix></nx-datepicker-toggle>
                    <nx-datepicker #dateFrom></nx-datepicker>
                </nx-formfield>
            </div>
            <div nxCol="12,12,12,4">
                <nx-formfield label="{{ 'callMeBack.dateFieldLabel' | translate }}">
                    <input nxDatefield nxInput [datepicker]="dateTo" formControlName="dateTo"
                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                    <nx-datepicker-toggle [for]="dateTo" nxFormfieldSuffix></nx-datepicker-toggle>
                    <nx-datepicker #dateTo></nx-datepicker>
                </nx-formfield>
            </div>
            <div nxCol="12,12,12,4">
                <nx-radio-toggle formControlName="type">
                    <nx-radio-toggle-button [value]="filterType.all">
                        <span translate>Všetky</span>
                    </nx-radio-toggle-button>
                    <nx-radio-toggle-button [value]="filterType.unprocessed">
                        <span translate>Nespracované</span>
                    </nx-radio-toggle-button>
                </nx-radio-toggle>
            </div>
        </div>
        <div nxRow>
            <div nxCol="12,12,12,4">
                <nx-formfield label="{{ 'b2b.upload-form.policy-number' | translate }}">
                    <input nxInput formControlName="policyNumber" type="text" />
                </nx-formfield>
            </div>
            <div nxCol="12,12,12,4">
                <button nxButton="primary" type="submit">
                    {{ 'b2b.search-btn' | translate }}
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #toDownload>
    <div class="scroll-container">
    <table nxTable nxSort (sortChange)="sortTable($event)">
        <thead>
            <tr nxTableRow>
                <th nxHeaderCell nxSortHeaderCell="createTs">{{ 'b2b.documents.created-at' | translate }}</th>
                <th nxHeaderCell nxSortHeaderCell="lastChangedTs">{{ 'b2b.documents.updated-at' | translate }}</th>
                <th nxHeaderCell nxSortHeaderCell="dms2numPz">{{ 'b2b.documents.policy-number' | translate }}</th>
                <th nxHeaderCell nxSortHeaderCell="dms2shortNote">{{ 'b2b.documents.original-file-name' | translate }}
                </th>
                <th nxHeaderCell>{{ 'b2b.documents.type' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.category' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.status' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.document-download' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.show-parts' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr nxTableRow *ngFor="let item of partnerDocumentListPage">
                <td nxTableCell>{{ item.createTs | dateFormat }}</td>
                <td nxTableCell>{{ item.lastChangedTs | dateFormat }}</td>
                <td nxTableCell>{{ item.dms2numPz }}</td>
                <td nxTableCell longText>{{ item.dms2shortNote }}</td>
                <td nxTableCell>{{ item.dms2docBrandLabel }}</td>
                <td nxTableCell>{{ item.dms2docCategoryLabel }}</td>
                <td nxTableCell>{{ item.dms2processStatusLabel }}</td>
                <td nxTableCell>
                    <nx-link>
                        <a href="{{ documentDownloadUrl(item.dms2numPz, item.itemId) }}" target="_blank">
                            <nx-icon name='download'></nx-icon>
                            {{'b2b.documents.download' | translate}}
                        </a>
                    </nx-link>
                </td>
                <td nxTableCell>
                    <nx-link>
                        <a (click)="showParts(item)">
                            {{ 'b2b.documents.show-parts' | translate }}
                        </a>
                    </nx-link>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
    <div nxRow class="nx-margin-top-s">
        <div nxCol="12" class="justify-end">
            <nx-pagination class="pagination" [count]="partnerDocumentList.length" [page]="page" type="advanced"
                [perPage]="elementsPerPage" (goPrev)="prevPage()" (goNext)="nextPage()" (goPage)="goToPage($event)">
            </nx-pagination>
        </div>
    </div>
</ng-template>

<ng-template #sentToAsp>
    <div class="scroll-container">
    <table nxTable nxSort (sortChange)="sortTable($event)">
        <thead>
            <tr nxTableRow>
                <th nxHeaderCell nxSortHeaderCell="createTs">{{ 'b2b.documents.created-at' | translate }}</th>
                <th nxHeaderCell nxSortHeaderCell="lastChangedTs">{{ 'b2b.documents.updated-at' | translate }}</th>
                <th nxHeaderCell nxSortHeaderCell="dms2numPz">{{ 'b2b.documents.policy-number' | translate }}</th>
                <th nxHeaderCell nxSortHeaderCell="dms2shortNote">{{ 'b2b.documents.original-file-name' | translate }}
                </th>
                <th nxHeaderCell>{{ 'b2b.documents.type' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.category' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.status' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.document-download' | translate }}</th>
                <th nxHeaderCell>{{ 'b2b.documents.show-parts' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr nxTableRow *ngFor="let item of partnerDocumentListPage">
                <td nxTableCell>{{ item.createTs | dateFormat }}</td>
                <td nxTableCell>{{ item.lastChangedTs | dateFormat }}</td>
                <td nxTableCell>{{ item.dms2numPz }}</td>
                <td nxTableCell longText>{{ item.dms2shortNote }}</td>
                <td nxTableCell>{{ item.dms2docBrandLabel }}</td>
                <td nxTableCell>{{ item.dms2docCategoryLabel }}</td>
                <td nxTableCell>{{ item.dms2processStatusLabel }}</td>
                <td nxTableCell>
                    <nx-link>
                        <a href="{{ documentDownloadUrl(item.dms2numPz, item.itemId) }}" target="_blank">
                            <nx-icon name='download'></nx-icon>
                            {{'b2b.documents.download' | translate}}
                        </a>
                    </nx-link>
                </td>
                <td nxTableCell>
                    <nx-link>
                        <a (click)="showParts(item)">
                            {{ 'b2b.documents.show-parts' | translate }}
                        </a>
                    </nx-link>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
    <div nxRow class="nx-margin-top-s">
        <div nxCol="12" class="justify-end">
            <nx-pagination class="pagination" [count]="partnerDocumentList.length" [page]="page" type="advanced"
                [perPage]="elementsPerPage" (goPrev)="prevPage()" (goNext)="nextPage()" (goPage)="goToPage($event)">
            </nx-pagination>
        </div>
    </div>
</ng-template>